export interface CCSyncDetails {
  startDate: string, // ISO date string
  endDate: string // ISO date string
}

export enum CCSyncStatus {
  STALE = 'STALE', // default, button clickable
  PROCESSING = 'PROCESSING', // disabled
  FAILED = 'FAILED', // red
  FINISHED = 'FINISHED', // success (green)
}